import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'terms' | 'privacy' | null>(null);
  return <footer className="py-12 px-6 border-t border-white/5 bg-navy-900 text-center" data-id="element-1">
      <div className="max-w-2xl mx-auto space-y-8" data-id="element-2">
        {/* Disclaimer */}
        <div className="text-xs text-cream-100/40 leading-relaxed max-w-lg mx-auto border border-white/5 p-4 rounded-lg bg-navy-800/30" data-id="element-3">
          <p data-id="element-4">
            DISCLAIMER: The Sleep-Shifts Survival System is an organizational
            tool for parents, not medical advice. It does not replace
            professional guidance for pediatric sleep issues or postpartum
            mental health concerns. Always consult your pediatrician or
            healthcare provider for medical needs.
          </p>
        </div>

        {/* Links */}
        <div className="flex justify-center gap-6 text-sm text-cream-100/60" data-id="element-5">
          <button onClick={() => setActiveModal('terms')} className="hover:text-gold-400 transition-colors underline decoration-white/10 underline-offset-4" data-id="element-6">
            Terms of Service
          </button>
          <button onClick={() => setActiveModal('privacy')} className="hover:text-gold-400 transition-colors underline decoration-white/10 underline-offset-4" data-id="element-7">
            Privacy Policy
          </button>
        </div>

        <p className="text-xs text-cream-100/20" data-id="element-8">
          © {new Date().getFullYear()} Sleep-Shifts Survival System. All rights
          reserved.
        </p>
      </div>

      {/* Terms Modal */}
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Terms of Service" data-id="element-9">
        <p data-id="element-10">
          <strong data-id="element-11">1. Acceptance of Terms</strong>
          <br data-id="element-12" />
          By purchasing and downloading the Sleep-Shifts Survival System, you
          agree to these terms. This product is for personal use only.
        </p>
        <p data-id="element-13">
          <strong data-id="element-14">2. Intellectual Property</strong>
          <br data-id="element-15" />
          All content, including the PDF guide, planner, and scripts, is the
          property of Sleep-Shifts Survival System. You may not redistribute,
          resell, or share these materials.
        </p>
        <p data-id="element-16">
          <strong data-id="element-17">3. Refund Policy</strong>
          <br data-id="element-18" />
          Due to the digital nature of this product, all sales are final.
          However, if you are unsatisfied, please contact support for
          assistance.
        </p>
        <p data-id="element-19">
          <strong data-id="element-20">4. Limitation of Liability</strong>
          <br data-id="element-21" />
          We are not responsible for any outcomes resulting from the use of this
          system. It is a tool for coordination, not a medical prescription.
        </p>
      </Modal>

      {/* Privacy Modal */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Privacy Policy" data-id="element-22">
        <p data-id="element-23">
          <strong data-id="element-24">1. Information Collection</strong>
          <br data-id="element-25" />
          We collect only the information necessary to process your transaction
          and deliver your digital product (name, email, payment details).
        </p>
        <p data-id="element-26">
          <strong data-id="element-27">2. Use of Information</strong>
          <br data-id="element-28" />
          Your email is used to send your download link and occasional product
          updates. We do not sell your data to third parties.
        </p>
        <p data-id="element-29">
          <strong data-id="element-30">3. Security</strong>
          <br data-id="element-31" />
          We use industry-standard encryption to protect your payment
          information during transmission.
        </p>
        <p data-id="element-32">
          <strong data-id="element-33">4. Cookies</strong>
          <br data-id="element-34" />
          This site uses minimal cookies necessary for site functionality and
          analytics to improve user experience.
        </p>
      </Modal>
    </footer>;
}